<template>
  <div class="page">

    <div style="padding-top:150px;">
      <div style="width: 461px; height: 280px; background-color: rgba(255,255,255,0.5); border-radius: 6px; margin: auto;">
        <div style="text-align:center; padding-top:20px;">
          <span style="color: #000000; font-size: 18px;">【黑神话·悟空】管理系统（Z5）</span>
        </div>
        <div style="padding-top: 10px">
            <table style="width: 100%">
              <tr>
                <td style="width: 80px; text-align: right; font-size: 13px; color:#222222; padding: 10px">
                    账号：
                </td>
                <td style=" text-align: left; padding: 10px">
                    <input type="text" v-model="account" style="background-color: white; width: 220px; border-radius: 3px; outline: none; border: 1px solid #dcdfe6; padding: 10px 15px" />
                </td>
              </tr>
              <tr>
                <td style="width: 80px; text-align: right; font-size: 13px; color:#222222; padding: 10px">
                  密码：
                </td>
                <td style=" text-align: left; padding: 10px">
                  <input type="password" v-model="pwd" style="background-color: white; width: 220px; border-radius: 3px; outline: none; border: 1px solid #dcdfe6; padding: 10px 15px" />
                </td>
              </tr>
              <tr>
                <td style="width: 80px; text-align: right; color:white; padding: 10px">

                </td>
                <td style=" text-align: left; padding: 10px; padding-top: 20px">
                    <input @click="userLogin" type="button" value="登 录" style="background-color: #42b983; border-radius: 3px; color: white; font-size: 15px; cursor: pointer; padding: 10px 30px; width: 252px; border: 0" />
                </td>
              </tr>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosPost} from "@/main";
// import axios from "axios";
import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";

export default {
  name:"IndexPage",
  data(){
    return{
      account:"",
      pwd:"",
    }
  },
  mounted() {
    closeLoading()
  },
  methods:{
    userLogin(){
      let that=this
      if(this.account==""){
        toask("请输入登录账号！",6)
        return
      }
      if(this.pwd==""){
        toask("请输入登录密码！",6)
        return
      }
      loading("登录中")
      axiosPost(DO_NET_URL+"Admin/AdminLogin?account="+this.account+"&pwd="+this.pwd, "",function (res){
        console.log(res)
        closeLoading()
        if(res.code==200){
          localStorage.setItem("iwa_token",res.data.token)
          localStorage.setItem("permissions",res.data.authority)
          localStorage.setItem("name",res.data.name)
          that.$router.replace('home')
        }else{
          toask(res.data,6)
        }
      })
    }
  }
}
</script>

<style scoped>
  .page{
    min-height: 100vh;
    background-size: 100%;
    background-image: url('../assets/index/hshwk.jpg');
  }
</style>